import React from 'react';
import { Modal } from 'react-bootstrap';

interface BottomDrawerProps {
	show: boolean;
	onClose: () => void;
	title?: string;
	children: React.ReactNode;
	footer?: React.ReactNode;
}

const BottomDrawer: React.FC<BottomDrawerProps> = ({
	show,
	onClose,
	title,
	children,
	footer,
}) => {
	return (
		<Modal
			show={show}
			onHide={onClose}
			className="bottom-drawer-modal"
			dialogClassName="bottom-drawer-dialog"
			contentClassName="bottom-drawer-content">
			<Modal.Header className="border-0 pb-2" closeButton>
				{title && (
					<Modal.Title className="w-100 text-center fw-semibold">
						{title}
					</Modal.Title>
				)}
			</Modal.Header>
			<Modal.Body className="pt-4 px-3">{children}</Modal.Body>
			{footer && (
				<Modal.Footer className="border-0 pt-2 justify-content-center">
					{footer}
				</Modal.Footer>
			)}
		</Modal>
	);
};

export default BottomDrawer;
